
  /*
   * text clear
   */
  $(document).on("click", ".text_nav_design .clear_btn", function () {
    if ($(".back_tab.tab_items.active")[0]) {
      $("#design-text").val("");
      $(".back_text_preview .text_ctent").text("");
      $("#design-text").val("");
      $(".back_image .cstm_textup").text("");
      $('.back_uploaded_content').html('');
      $('.font_sstyle_back').html('');
    }
    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview .text_ctent").text("");
      $("#design-text").val("");
      $(".front_image .cstm_textup").text("");
      $('.front_uploaded_content').html('');
      $('.font_sstyle_front').html('');
    }
  });

/* upload clear*/

$(document).on('click','.upload_nav_design .clear_btn',function(){

  $('#preview_img').removeAttr('src');
   $('#cropped_image').removeAttr('src');
 $('.fileinput').val('');

   if ($(".front_image.active")[0]) {

     $('#imageCanvas').removeAttr('width');
      $('#imageCanvas').removeAttr('height');
     $('.front_image_url').html('');
     $('.front_image .resizable').removeClass('active');
     $('.front_image .resizable').addClass('hide');
     $('.front_image img.uploadingimg').removeAttr('src');
     $('.front_image .logo_img').addClass('hide');
     $('.front_image .logo_img_gal').removeAttr('src');

        setTimeout(function () {
      $('.front_image').removeClass('both_textactive');
      $("#inverseCheckbox").prop("checked",false);
      $("#inverseCheckbox").attr("disabled",'disabled');
      }, 1000);

    }
    if ($(".back_image.active")[0]) {
       $('#imageCanvasback').removeAttr('width');
      $('#imageCanvasback').removeAttr('height');
   $('.back_image img.uploadingimg').removeAttr('src');
       $('.back_image .resizable').removeClass('active');
     $('.back_image .resizable').addClass('hide');
      $('.back_image_url').html('');
      $('.back_image .logo_img').addClass('hide');
     $('.back_image .logo_img_gal').removeAttr('src');

        setTimeout(function () {
      $('.back_image').removeClass('both_textactive');
      $("#backinverseCheckbox").prop("checked",false);
      $("#backinverseCheckbox").attr("disabled",'disabled');
      }, 1000);

    }

});


$(document).on('click','.gallery_nav_design .clear_btn, .outergallery_nav_design .clear_btn',function(){

    if ($(".back_tab.tab_items.active")[0]) {
      $('.back_image .logo_img').addClass('hide');
      $('.back_image .logo_img_gal').removeAttr('src');
      $('.back_image_url').html('');

var backhtml = $('.back_image .cstm_textup').html();
var logoback = $('.back_image img.logo_img_gal').attr('src');
  if(backhtml !='' && logoback != undefined){
      $('.back_image').addClass('both_textactive');
  }else{
     $('.back_image').removeClass('both_textactive');
  }

    }
    if ($(".front_tab.tab_items.active")[0]) {
      $('.front_image .logo_img_gal').removeAttr('src');
      $('.front_image .logo_img').addClass('hide');
      $('.front_image_url').html('');

var fronthtml1 = $('.front_image .cstm_textup').html();
var logofront = $('.front_image img.logo_img_gal').attr('src');
  if(fronthtml1 !='' && logofront != undefined){
      $('.front_image').addClass('both_textactive');
  }else{
     $('.front_image').removeClass('both_textactive');
  }
    }
});
